import {getPushNotificationLogByUserId} from "../../../api/graphql/pushNotification";
import {useState} from "react";
import {useRecoilState, useSetRecoilState} from "recoil";
import {
    globalHeaderPushNotificationDataState,
    globalUnreadPushNotificationCountState
} from "../../../_common/global_state";

export const useGetHeaderPushNotificationLogByUserId = () => {
    const setUnreadPushNotificationCount = useSetRecoilState(globalUnreadPushNotificationCountState);
    const [data, setData] = useRecoilState(globalHeaderPushNotificationDataState)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    const fetchLog = async (offset = 0) => {
        try {
            setLoading(true)
            setError(false)
            const id = localStorage.getItem("userid")
            const {getPushNotificationLogByUserId: res} = await getPushNotificationLogByUserId(id, 8, offset)

            if (!Array.isArray(res?.data) || res?.errKey) throw new Error("Could not load push notifications");
            setData(previous => offset ? [...new Map([...(previous || []), ...res.data].map(item => [item._id, item])).values()] : res.data)
            setUnreadPushNotificationCount(res?.unreadTotal)
            setTotal(res?.total)
            setLoading(false)
        } catch (e) {
            setError(true);
            return false;
        } finally {
            setLoading(false);
        }
    }

    return [data, total, fetchLog, loading, error]
}